module.exports = __webpack_public_path__ + "img/Butterfly_00228.50ef7c27.png";